import { PromotionKarteConfig, PromotionKarteHistory } from '@/common/model/promotionKarte'

export const PromotionKarteApiPath = {
  GET_CONFIGS: '/api/promotion-karte/configs', // GET List Configs
  UPDATE_CONFIGS: '/api/promotion-karte/configs', // PUT Upsert Configs
  GET_HISTORY: '/api/promotion-karte/history' // GET Change History
}

export type PromotionKarteApiPath =
  (typeof PromotionKarteApiPath)[keyof typeof PromotionKarteApiPath]

export interface GetPromotionKarteConfigsVars {}

// upsert 用の1件（promotion_type がキー。未指定フィールドは変更なし）
export interface PromotionKarteConfigItem {
  promotion_type: string
  api_status?: string | null
  integration_mode?: string | null
  notify_mode?: string | null
  target_list_mode?: string | null
  enabled?: boolean | null
  admin_path?: string | null
  admin_path_v6?: string | null
  param_carry?: string | null
}

export interface UpdatePromotionKarteConfigsVars {
  configs: PromotionKarteConfigItem[]
}

export interface PromotionKarteConfigsResponse {
  items: PromotionKarteConfig[]
}

export type UpdatePromotionKarteConfigsResponse = PromotionKarteConfigsResponse

export interface GetPromotionKarteHistoryVars {}

export interface PromotionKarteHistoryResponse {
  items: PromotionKarteHistory[]
}
